export default {
      id: "icon--tick-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--tick-usage",
      toString: function () {
        return this.url;
      }
    }